import { ChangeDetectionStrategy, Component } from '@angular/core';
import {provideNativeDateAdapter} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';

@Component({
  selector: 'app-date-range-picker-overview-example',
  templateUrl: './date-range-picker-overview-example.component.html',
  styleUrl: './date-range-picker-overview-example.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideNativeDateAdapter()],
})
export class DateRangePickerOverviewExampleComponent {

}
